/**
 * @Description: 耗材的色带颜色信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  RibbonColorDefModel,
  RibbonColorDefSearchModel,
  RibbonColorDefPageSearchModel,
  RibbonColorDefAddModel,
  RibbonColorDefUpdateModel,
  IdsModel
} from '@/model/product/RibbonColorDefModel'

const baseUrl = Route.product + '/ribbonColorDef'

/**
 * 搜索分页数据
 */
export const pageSearchRibbonColorDef = (param: RibbonColorDefPageSearchModel) => {
  return https().request<RootObject<PageRespModel<RibbonColorDefModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchRibbonColorDef = (param: RibbonColorDefSearchModel) => {
  return https().request<RootObject<RibbonColorDefModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getRibbonColorDef = (id: number) => {
  return https().request<RootObject<RibbonColorDefModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addRibbonColorDef = (param: RibbonColorDefAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateRibbonColorDef = (param: RibbonColorDefUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeRibbonColorDef = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveRibbonColorDef = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
